// extracted by mini-css-extract-plugin
module.exports = {"label":"BaseCheckbox_label__3FKd3","error":"BaseCheckbox_error__13JFK"};